<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'user-load-pallets-orders'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
  <div style="margin-top: 1em">
    <div class="card">
      <div class="header-card">
        <div class="container-title">
          <!--
            <button (click)="goToLoadsPage()" class="btn-circle bg-yellow" style="margin-right:1em" >
              <i class="pi pi-arrow-left"></i>
            </button>
          -->
          <h2 class="title-main">{{'UserPages.UserLoadMasterOrders.PageTitle' | translate}}</h2>
        </div>
        <div class="col-12 md:col-6 p-fluid flex align-items-center">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="{{'UserPages.UserLoadOrders.SearchProducts' | translate}}" class="p-inputtext-sm"  [(ngModel)]="searchTerm" (input)="filterLoads()" />
          </span>
        </div>
        <div></div>

      </div>
      <div class="body-card">
        <div class="subtitle-container">
          <h4 class="subtitle">
            {{'UserPages.UserLoadContainersOrders.Exporter' | translate}}
          </h4>
          <button type="button" pButton pRipple
            icon="pi pi-file-excel"
            class="p-button-success mr-2 button-success-style"
            pTooltip="XLS"
            (click)="exportExcel(loadMasterTable)"
            [loading]="loading"
            tooltipPosition="bottom"
            [style]="{'width':'fit-content', 'margin-left': '2px'}">
            {{ 'UserPages.UserLoadOrders.ExportExcel' | translate }}
          </button>
        </div>
        <div class="container-filters filters-size">
          <section class="section-info" *ngIf="profile">
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-user" style="margin-right:.5em; color:grey"></i>
                {{companyName}}
              </section>
              <section class="section-data">
                <i class="pi pi-at" style="margin-right:.5em; color:grey"></i>
                {{profile.contactEmail}}
              </section>
            </section>
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-map-marker" style="margin-right:.5em; color:grey"></i>
                {{profile.contactAddress}}
              </section>
              <section class="section-data">
                <i class="pi pi-phone" style="margin-right:.5em; color:grey"></i>
                {{profile.contactPhone}}
              </section>
            </section>
          </section>

          <div class="section-filters">
            <div class="grid justify-content-end align-items-center">
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="container-filter"
                    [options]="containerFilter"
                    (onChange)="loadMasterTable.filter($event.value, 'delivery.containerNumber', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    [(ngModel)]="selectedContainers"
                    class="multiselect"
                  />
                  <label for="container-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.containerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="week-filter"
                    [options]="weekFilter"
                    (onChange)="loadMasterTable.filter($event.value, 'delivery.week', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="week-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.weekFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="importer-filter"
                    [options]="importerFilter"
                    (onChange)="loadMasterTable.filter($event.value, 'pallet.importOrderDetail.importOrder.importer.companyName', 'in')"
                    [filter]="true"
                    [(ngModel)]="selectedCompanies"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="importer-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.importerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="specie-filter"
                    [options]="specieFilter"
                    (onChange)="loadMasterTable.filter($event.value, 'pallet.excelImportSpecies', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="specie-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.specieFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="variety-filter"
                    [options]="varietyFilter"
                    (onChange)="loadMasterTable.filter($event.value, 'pallet.excelImportVariety', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="variety-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.varietyFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="ship-filter"
                    [options]="shipFilter"
                    (onChange)="loadMasterTable.filter($event.value, 'delivery.ship', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="ship-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.naveFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                  id="year-filter"
                  [options]="years"
                  [(ngModel)]="yearSelect"
                  class="multiselect"
                  [selectionLimit]="1"
                  (onChange)="searchLoadContainers($event)"
                  placeholder="{{'MyLoadFilter.SelectYear' | translate}}"
                  >
                  </p-multiSelect>
                  <label for="year-filter">
                    {{'MyLoadFilter.YearLabel' | translate}}
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="container-table">
          <div  class="section-table">
            <p-table
              #loadMasterTable
              [value]="filteredRegisters"
              dataKey="product.pallet.id"
              [loading]="loading"
              [paginator]="true"
              [rows]="100"
              [rowsPerPageOptions]="[100, 200, 500, 1000]"
              [scrollable]="true"
              [resizableColumns]="true"
              columnResizeMode="expand"
              scrollHeight="800px"
              (onFilter)="filterTable($event)"
              [tableStyle]="{ 'min-width': '50rem' }"
              [globalFilterFields]="['delivery.containerNumber', 'delivery.week', 'pallet.importOrderDetail.importOrder.importer.companyName', 'pallet.excelImportSpecies', 'pallet.excelImportVariety', 'delivery.ship']"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Mostrando desde {first} hasta {last} de {totalRecords} resultados"
              styleClass="p-datatable-gridlines">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ImportOrderIdHeader' | translate }}</th>
                  <!-- <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ImportDetailIdHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ExportOrderIdHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PalletIdHeader' | translate }}</th> -->
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.FolioHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TransportTypeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.SpecieHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.VarietyHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.GrowerHeader' | translate }}</th>
                  <th>CSG</th>
                  <th>CSP</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.SpeciesSizeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.HarvestDateHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.QualityControlDateHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackagingHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PalletTypeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabelHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.BagTypeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.BoxSizeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.NetWeightHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.FridgeStorageHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.BoxesPerPalletHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.MarkHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ContainerNumberHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.GradeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TemptaleHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.OriginCountryHeader' | translate }}</th>
                  <!-- <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LoadingWeekHeader' | translate }}</th> -->
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.BLNoHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.BookingNoHeader' | translate }}</th>
                  <!-- <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ContainerNoHeader' | translate }}</th> -->
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ExporterHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ExporterEmailHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ImporterHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ImporterEmailHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ConsigneeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ConsigneeEmailHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.NotifyHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.NotifyEmailHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.InstructionsHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.GrossWeight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CBM' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Temperature' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PlaceReceipt' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.OriginPort' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DestinationPort' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.OriginAirport' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DestinationAirport' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Week' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PlaceDelivery' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.VesselName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Voyage' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.MovementType' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ETD' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ETA' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.OceanFreight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Inland' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LocalCharges' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Customs' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Surcharge' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Others' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.FreightPayable' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ShippedBoard' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.IssuePlace' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.IssueDate' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ExcessValue' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PricePerBox' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Incoterms' | translate }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.pallet.importOrderDetail.importOrder.sequence  }}</td>
                  <!-- <td>{{ product.pallet.importOrderDetailId }}</td>
                  <td>{{ product.pallet.importOrderDetail?.exportOffer?.id }}</td>
                  <td>{{ product.pallet.id }}</td> -->
                  <td>{{ product.pallet.palletNumber }}</td>
                  <td>{{ getTransportName(product.pallet.importOrderDetail.importOrder.transportType) }}</td>
                  <td>{{ product.pallet.excelImportSpecies }}</td>
                  <td>{{ product.pallet.excelImportVariety }}</td>
                  <td>{{ product.pallet.producer }}</td>
                  <td>{{ product.pallet.csg }}</td>
                  <td>{{ product.pallet.csp }}</td>
                  <td>{{ product.pallet.speciesSize }}</td>
                  <td>{{ product.pallet.excelImportHarvestDate }}</td>
                  <td>{{ product.pallet.excelImportQualityControlDate }}</td>
                  <td>{{ product.pallet.excelImportPackaging }}</td>
                  <td>{{ product.pallet.excelImportPalletType }}</td>
                  <td>{{ product.pallet.excelImportTag }}</td>
                  <td>{{ product.pallet.excelImportBagType }}</td>
                  <td>{{ product.pallet.excelImportBoxSize }}</td>
                  <td>{{ product.pallet.excelImportNetWeight }}</td>
                  <td>{{ product.pallet.excelImportFridgeStorage }}</td>
                  <td>{{ product.pallet.excelImportBoxesPerPallet }}</td>
                  <td>{{ product.pallet.excelImportMark }}</td>
                  <td>{{ product.pallet.excelImportContainerNumber }}</td>
                  <td>{{ product.pallet.excelImportGrade }}</td>
                  <td>{{ product.pallet.excelImportTemptale }}</td>
                  <td>{{ product.pallet.excelImportOriginCountry }}</td>
                  <!-- <td>{{ product.pallet.excelImportLoadWeek }}</td> -->
                  <td>{{ product.delivery?.bl }}</td>
                  <td>{{ product.delivery?.booking }}</td>
                  <!-- <td>{{ product.delivery?.containerNumber }}</td> -->
                  <td>{{ product.pallet.importOrderDetail?.exportOffer?.exporter?.companyName }}</td>
                  <td>{{ product.pallet.importOrderDetail?.exportOffer?.exporter?.contactEmail }}</td>
                  <td>{{ product.pallet.importOrderDetail?.importOrder?.importer?.companyName }}</td>
                  <td>{{ product.pallet.importOrderDetail?.importOrder?.importer?.contactEmail }}</td>
                  <td>{{ product.delivery?.consigneeCompanyName }}</td>
                  <td>{{ product.delivery?.consigneeContactEmail }}</td>
                  <td>{{ product.delivery?.notifierCompanyName }}</td>
                  <td>{{ product.delivery?.notifierContactEmail }}</td>
                  <td>{{ product.delivery?.deliveryInstructions }}</td>
                  <td>{{ product.delivery?.grossWeight }}</td>
                  <td>{{ product.delivery?.containerCbm }}</td>
                  <td>{{ product.delivery?.containerTemperature }}</td>
                  <td>{{ product.delivery?.placeReceipt }}</td>
                  <td>{{ product.delivery?.departurePort?.name }}</td>
                  <td>{{ product.delivery?.destinationPort?.name }}</td>
                  <td>{{ product.delivery?.departureAirport?.name }}</td>
                  <td>{{ product.delivery?.destinationAirport?.name }}</td>
                  <td>{{ product.delivery?.week }}</td>
                  <td>{{ product.delivery?.placeDelivery }}</td>
                  <td>{{ product.delivery?.ship }}</td>
                  <td>{{ product.delivery?.voyageNumber }}</td>
                  <td>{{ product.delivery?.typeMovement }}</td>
                  <td>{{ product.delivery?.etd | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product.delivery?.eta | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product.delivery?.oceanFreight }}</td>
                  <td>{{ product.delivery?.inland }}</td>
                  <td>{{ product.delivery?.localCharges }}</td>
                  <td>{{ product.delivery?.customs }}</td>
                  <td>{{ product.delivery?.surcharge }}</td>
                  <td>{{ product.delivery?.otherCosts }}</td>
                  <td>{{ product.delivery?.freightPayableAt }}</td>
                  <td>{{ product.delivery?.shippedOnBoard }}</td>
                  <td>{{ product.delivery?.placeIssue }}</td>
                  <td>{{ product.delivery?.dateIssue | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product.delivery?.excessValueDeclaration }}</td>
                  <td>$ {{ product.pallet.importOrderDetail?.price }}</td>
                  <td>{{ product.pallet.importOrderDetail?.incoterms }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-user-dashboard>
